export const MEDIA_TYPE = {
    IMAGE: "IMAGE",
    VIDEO: "VIDEO",
    LOTTIE: "LOTTIE",
}

export const MODE = {
    LIGHT: "LIGHT",
    DARK: "DARK",
}

export const DECORATIONS = {
    SOCIAL_1_1: "SOCIAL_1_1",
    SOCIAL_3_4: "SOCIAL_3_4",
    SOCIAL_9_16: "SOCIAL_9_16",
    BROWSER: "BROWSER",
}

export const ALIGN = {
    LEFT: "LEFT",
    RIGHT: "RIGHT",
    TOP: "TOP",
    MIDDLE: "MIDDLE",
    BOTTOM: "BOTTOM",
    TOP_LEFT: "TOP-LEFT",
    TOP_RIGHT: "TOP-RIGHT",
    BOTTOM_LEFT: "BOTTOM-LEFT",
    BOTTOM_RIGHT: "BOTTOM-RIGHT",
    HORIZONTAL: "HORIZONTAL",
    VERTICAL: "VERTICAL",
}

export const RATIO = {
    R_1_1: "1:1",
    R_1_2: "1:2",
    R_2_1: "2:1",
    R_3_4: "3:4",
    R_4_3: "4:3",
    R_16_9: "16:9",
    R_9_16: "9:16",
    R_21_9: "21:9",
    R_9_21: "9:21",
    R_26_14: "26:14",
}